import * as React from 'react';

import * as styles from './styles.css';
import { INewbuildingDecoration } from '../../../../types/newobject/newbuildingDecorations';
import { VerticalSliderFullscreen } from '../../../VerticalSlider';
import { NewbuildingDecorationItem } from '../../parts/NewbuildingDecorationItem';

interface INewbuildingDecorationProps {
  items: Pick<INewbuildingDecoration, 'title' | 'images' | 'shortDescription'>[];
  popup: React.ReactNode;
  onItemClick(i: number): void;
}

export function NewbuildingDecorationItems({ items, onItemClick, popup }: INewbuildingDecorationProps) {
  return (
    <div className={styles['decorations-container']}>
      <VerticalSliderFullscreen onItemClick={onItemClick} arrowPositionTop={'79px'} arrowOffset={6}>
        {items.map(({ title, images, shortDescription }) => (
          <NewbuildingDecorationItem
            key={title}
            title={title}
            imgUrl={images[0]?.url}
            shortDescription={shortDescription}
          />
        ))}
      </VerticalSliderFullscreen>
      {popup}
    </div>
  );
}
